import { useEffect, useState } from "react";
import api from "../../lib/api";

/* Saved household travellers (name + relation) for per-person assignment dropdowns.
   Pass a changing `refresh` value (e.g. a form-open flag) to re-fetch. */
export function useTravelers(refresh) {
  const [travelers, setTravelers] = useState([]);
  useEffect(() => {
    api.get("/trips/travelers").then((r) => setTravelers(r.data.items || [])).catch(() => setTravelers([]));
  }, [refresh]);
  return travelers;
}
